export const CONTAINER_TYPES_LOAD = 'CONTAINER_TYPES_LOAD'
export const containerTypesLoad = (): containerTypesLoadAction => ({
  type: CONTAINER_TYPES_LOAD
})

export const CONTAINER_TYPES_LOAD_SUCCESS = 'CONTAINER_TYPES_LOAD_SUCCESS'
export const containerTypesLoadSuccess = (
  containerTypes: string[]
): containerTypesLoadSuccessAction => ({
  type: CONTAINER_TYPES_LOAD_SUCCESS,
  containerTypes
})

export const CONTAINER_TYPES_LOAD_FAIL = 'CONTAINER_TYPES_LOAD_FAIL'
export const containerTypesLoadFailure = (
  error
): containerTypesLoadFailAction => ({
  type: CONTAINER_TYPES_LOAD_FAIL,
  error
})

// INTERFACEs

export interface containerTypesLoadAction {
  type: typeof CONTAINER_TYPES_LOAD
}

interface containerTypesLoadSuccessAction {
  type: typeof CONTAINER_TYPES_LOAD_SUCCESS
  containerTypes: string[]
}

interface containerTypesLoadFailAction {
  type: typeof CONTAINER_TYPES_LOAD_FAIL
  error: any
}
